import { barsIcon, targetIcon } from "./icons";

export const GoalsSection = ({
  personalGoals = "",
  howToReachGoals = "",
}) => {
  const personalItems = Array.isArray(personalGoals)
    ? personalGoals
    : personalGoals
    ? [personalGoals]
    : [];

  const howToItems = Array.isArray(howToReachGoals)
    ? howToReachGoals
    : howToReachGoals
    ? [howToReachGoals]
    : [];
  
  const showPersonalCard = personalItems.length > 0;
  const showHowToCard = howToItems.length > 0;

  const gridCols = showPersonalCard && showHowToCard ? "grid-cols-2" : "grid-cols-1";
  return (
    <div className="mb-10">
      <div className="relative h-full">

        {/* Cards */}
        <div className={`grid ${gridCols} gap-[29px]`}>
          {showPersonalCard && (
            <GoalCard
              icon={barsIcon}
              label="Personal Goals"
              items={personalItems}
            />
          )}

          {showHowToCard && (
            <GoalCard
              icon={targetIcon}
              label="How to Reach Goal"
              items={howToItems}
            />
          )}
        </div>

        {/* OUTLINE BORDER + DOTS — render only when there are cards */}
        {(showPersonalCard || showHowToCard) && (
          <>
            <div className="absolute -inset-[16px] pointer-events-none">
              <svg
                className="w-full h-full"
                viewBox="0 0 558 160"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
              >
                <path
                  d="
                    M13 1
                    H545
                    C551.627 1 557 6.37258 557 13
                    V145
                    C557 151.627 551.627 157 545 157
                    H13
                  "
                  className="stroke-REELTeal"
                  strokeWidth="2"
                />
              </svg>
            </div>

            {/* TOP LEFT DOT */}
            <div className="absolute z-20 -left-[8px] -top-[14px] -translate-x-1/2 -translate-y-1/2">
              <svg className="w-[19px] h-[19px]" viewBox="0 0 14 14" fill="none">
                <rect x="1" y="1" width="12" height="12" rx="6" fill="white" />
                <rect
                  x="1"
                  y="1"
                  width="12"
                  height="12"
                  rx="6"
                  className="stroke-REELTeal"
                  strokeWidth="2"
                />
                <circle cx="7" cy="7" r="3.5" className="fill-REELTeal" />
              </svg>
            </div>

            {/* BOTTOM LEFT DOT */}
            <div className="absolute z-20 -left-[8px] -bottom-[12px] -translate-x-1/2 translate-y-1/2">
              <svg className="w-[19px] h-[19px]" viewBox="0 0 14 14" fill="none">
                <rect x="1" y="1" width="12" height="12" rx="6" fill="white" />
                <rect
                  x="1"
                  y="1"
                  width="12"
                  height="12"
                  rx="6"
                  className="stroke-REELTeal"
                  strokeWidth="2"
                />
                <circle cx="7" cy="7" r="3.5" className="fill-REELTeal" />
              </svg>
            </div>
          </>
        )}

      </div>
    </div>
  );
};

const GoalCard = ({ icon = <></>, label = "", items = [] }) => (
  <div className="relative bg-teal-25 rounded-[14px] p-[16px]">
    <div className="flex gap-4">
      <div className="min-w-[40px] min-h-[180px] flex items-start">
        {icon}
      </div>
      <div className="flex-1">
        <p className="font-bold text-[16px] text-teal-300 mb-[8px]">
          {label}
        </p>
        <ul className="ml-[4px] space-y-[10px] font-medium">
          {items.map((item) => (
            <li
              key={item}
              className="relative pl-[14px] text-[15px] text-gray-600"
            >
              <span className="absolute left-0 top-[6px] text-REELTeal">
                <svg className="w-[8px] h-[8px]" viewBox="0 0 6 6" fill="none">
                  <circle cx="3" cy="3" r="2" className="stroke-REELTeal" />
                </svg>
              </span>

              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

export default GoalsSection;